var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.games.length)?_c('div',{staticClass:"flex flex-col"},[_c('games-section',{staticClass:"flex-grow pt-32",attrs:{"games":_vm.games,"title-class":"text-4xl"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }